
import React from "react";
import { FormField, FormItem, FormLabel, FormControl, FormDescription } from "@/components/ui/form";
import { Checkbox } from "@/components/ui/checkbox";
import { UseFormReturn } from "react-hook-form";
import { z } from "zod";

// Import the schema to ensure type consistency
const formSchema = z.object({
  is_default: z.boolean().default(false),
  default_selected_option: z.boolean().default(false),
});

type FormValues = z.infer<typeof formSchema>;

interface DefaultOptionFieldProps {
  form: UseFormReturn<any>;
}

export function DefaultOptionField({ form }: DefaultOptionFieldProps) {
  return (
    <div className="space-y-4">
      {/* <FormField
        control={form.control}
        name="is_default"
        render={({ field }) => (
          <FormItem className="flex flex-row items-start space-x-3 space-y-0 rounded-md p-4">
            <FormControl>
              <Checkbox
                checked={field.value}
                onCheckedChange={field.onChange}
              />
            </FormControl>
            <div className="space-y-1 leading-none">
              <FormLabel>
                Default Option
              </FormLabel>
              <FormDescription>
                Mark this as the default option for this variant
              </FormDescription>
            </div>
          </FormItem>
        )}
      /> */}
      
      <FormField
        control={form.control}
        name="default_selected_option"
        render={({ field }) => (
          <FormItem className="flex flex-row items-start space-x-3 space-y-0 rounded-md p-4">
            <FormControl>
              <Checkbox
                checked={field.value}
                onCheckedChange={field.onChange}
              />
            </FormControl>
            <div className="space-y-1 leading-none">
              <FormLabel>
                Default Selected Option
              </FormLabel>
              <FormDescription>
                Mark this option as selected by default
              </FormDescription>
            </div>
          </FormItem>
        )}
      />
    </div>
  );
}
